import AssetComponentAPI from "../../../api/AssetComponentAPI";

export default {
  async assetСomponentsImport({commit}, data) {
    return await new AssetComponentAPI().excelImport(data);
  }
};
